import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-advisory-content-description',
  templateUrl: './advisory-content-description.component.html',
  styleUrls: ['./advisory-content-description.component.scss'],
})
export class AdvisoryContentDescriptionComponent {
  @Input() text: string;
}
